<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="eb-icon" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="7" width="14" height="14" rx="3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
    <path d="M6 7V6C6 4.34315 7.34315 3 9 3H18C19.6569 3 21 4.34315 21 6V15C21 16.6569 19.6569 18 18 18H17" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
    <path d="M6.99998 14H13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
    <path d="M6.99998 17H13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
    <path d="M6.99998 11H9.88887" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
  </svg>
</template>


  
